module.exports = "/_next/static/images/b899a2303f4ddb656bd1a23b91cf418a-row-1-with.svg";